"use strict";
var decorators_1 = require("./pipes/decorators");
exports.Pipe = decorators_1.Pipe;
//# sourceMappingURL=pipes.js.map


//////////////////
// WEBPACK FOOTER
// ./${exlibris_product}/npm_modules/February2023-PROD/prima/node_modules/ng-metadata/src/core/pipes.js
// module id = 493
// module chunks = 6